/*
  FAST-LANE CHECKOUT (James, 2026-08-19)

  A short whitelist of SKUs that skip the cart entirely: adding one sends the
  customer straight to checkout instead of opening the slide cart.

  Listens on the theme's own `variant:add` event, which every add path
  dispatches — the product form, quick buy, the FBT bundle and the PDP offer
  popup — so this works everywhere without touching any of them.

  CAPTURE PHASE, and it stops propagation. The cart drawer listens for the same
  event on document; letting it through first means the drawer opens and paints
  for a moment before the redirect throws it away. Capturing at document beats
  any bubble-phase listener, so nothing flashes.

  The SKUs live here rather than in theme settings because the list is short and
  changes rarely. If it starts moving often, move it to the hub the way the PDP
  offer's targeting works.
*/
(() => {
  const FAST_LANE_SKUS = new Set([
    // Blackline Reset 3 Pack Vibes Bundle
    'BLR3PRVB', // Rich
    'BLR3PFVB', // Fresh
    'BLR3PBVB', // Bold
    // BFCM copy of the Reset 3 Pack offer (R(A)-BF, 2026-10-30)
    'BLR3PRVB-BF', // Rich
    'BLR3PFVB-BF', // Fresh
    'BLR3PBVB-BF', // Bold
    // Drying Towel Welcome Bundle. The variants were recreated on 2026-08-24,
    // which changed two of the three SKUs — CVBLDT became CVBLDF and CRVBLDT
    // became CRVBLDF. The old codes are kept so historical carts still match.
    'CVBLDF',   // Carbon
    'CRVBLDF',  // Crimson
    'AVBLDT',   // Aqua
    'CVBLDT',   // Carbon (retired)
    'CRVBLDT',  // Crimson (retired)
    // The Longest Protection Blackline's Created
    'LPBCV',
    // #1 Rated Viral Drying Towel — colour x scent, 9 variants, $89.95.
    // Verified unique to that product, so matching on SKU cannot catch anything
    // else by accident.
    'BLDTCB',  'BLDTCF',  'BLDTCS',   // Carbon  / Bold, Fresh, Sweet
    'BLDTCRB', 'BLDTCRF', 'BLDTCRS',  // Crimson / Bold, Fresh, Sweet
    'BLDTABB', 'BLDTAF',  'BLDTAS',   // Aqua    / Bold, Fresh, Sweet
  ]);

  // These must stay in step with the shop metafield custom.free_ship_variants,
  // which is what the shipping-discount function reads. A SKU here but not there
  // sends the customer straight to checkout and then charges them shipping,
  // which is worse than the behaviour this replaced.

  const checkoutUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}checkout`.replace('//checkout', '/checkout');
  };

  // Guards a double-fire: the redirect is not instant, and a second event
  // arriving in the meantime would restart the navigation.
  let redirecting = false;

  document.addEventListener('variant:add', (event) => {
    if (redirecting) return;

    const items = (event.detail && event.detail.items) || [];
    const hit = items.some((item) => item && FAST_LANE_SKUS.has(item.sku));
    if (!hit) return;

    redirecting = true;
    event.stopPropagation();
    window.location.assign(checkoutUrl());
  }, true);
})();
